import http from "../../http-common.js";
import authHeader from "../user/auth-header.js";

class CourseDataService {
  getAll() {
    return http.get("/courses", { headers: authHeader() });
  }

  get(id) {
    return http.get(`/courses/${id}`, { headers: authHeader() });
  }

  create(data) {
    return http.post("/courses", data, { headers: authHeader() });
  }

  update(id, data) {
    return http.put(`/courses/${id}`, data, { headers: authHeader() });
  }

  delete(id) {
    return http.delete(`/courses/${id}`, { headers: authHeader() });
  }

  uploadPhoto(id, fileData) {
    return http.put(`/courses/${id}/photo`, fileData, {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new CourseDataService();
